export const ENTITY_COLORS = {
  portfolio: '#33becc',
  estate: '#7C5FE0',
  bp: '#D24724',
  unit: '#FBC211',
}

export const UNIT_INK = '#A16207'
